export const services = {
  rootUpdatable: Symbol.for('rootUpdatable'),
  config: Symbol.for('config'),
  logger: Symbol.for('logger'),
  getTokens: Symbol.for('getTokens'),
  handlers: Symbol.for('handlers'),
  modalService: Symbol.for('modalService'),
  i18nService: Symbol.for('i18nService'),
  history: Symbol.for('history'),
  utcomApi: Symbol.for('utcomApi'),
  apolloClient: Symbol.for('apolloClient'),
  withdrawService: Symbol.for('withdrawService'),
};

export const iocNames = services;
